import { resolvedFlightDeckClient, transformFlightDeckArtifactToProductConfiguration } from './flight-deck';
import { FlightDeckProductConfigurationArtifact, getProductConfigurationResult } from './types';

export default class ProductConfigurationProvider {
	private promise?: Promise<getProductConfigurationResult>;

	private async getProductConfigurationFlightDeck(): Promise<getProductConfigurationResult> {
		// TODO: remove flightDeckAssetsBaseUrl once Assets becomes it's own app
		const defaultResponse: getProductConfigurationResult = {
			data: { links: {}, products: {}, flightDeckAssetsBaseUrl: '' },
			error: false,
		};

		try {
			const artifact = (await resolvedFlightDeckClient.fetchConfigFromFlightDeck({
				name: 'app-switcher-fe',
				dimensions: {
					environmentType: 'prod',
				},
			})) as FlightDeckProductConfigurationArtifact;
			const data = transformFlightDeckArtifactToProductConfiguration(artifact);

			if (!data) {
				return defaultResponse;
			}

			return {
				data,
				error: false,
			};
		} catch (error) {
			console.error('Could not retrieve product config from Flight Deck: ', error);
			return {
				data: defaultResponse.data,
				error: true,
			};
		}
	}

	/**
	 * Get product configuration that typically contains customer facing images, name, description, icon, etc
	 */
	async getProductConfiguration(): Promise<getProductConfigurationResult> {
		if (!this.promise) {
			this.promise = this.getProductConfigurationFlightDeck();
		}

		// TODO: remove flightDeckAssetsBaseUrl once Assets becomes it's own app
		const defaultResponse: getProductConfigurationResult = {
			data: { links: {}, products: {}, flightDeckAssetsBaseUrl: '' },
			error: false,
		};

		try {
			const response = await this.promise;
			if (!response) {
				return defaultResponse;
			}
			return response;
		} catch (error) {
			console.error('Could not retrieve product config: ', error);
			return {
				data: defaultResponse.data,
				error: true,
			};
		}
	}
}
